import Vue from 'vue'
import Router from 'vue-router'
import store from '@/landing/store'

Vue.use(Router)

var routes = []

if (process.env.VUE_APP_FIREBASE_ENV === 'development') {
  routes.push({
    path: '/landing',
    name: 'landing',
    props: true,
    component: () => import('@/views/CustomTestLandingPage.vue')
  })
  routes.push({
    path: '/landing/:custom_slug/subscribed',
    name: 'testSubscribedPage',
    component: () => import('@/views/TestSubscribedPage.vue')
  })
  routes.push({
    path: '/landing/:custom_slug/unfurl',
    name: 'unfurlPage',
    component: () => import('@/views/Unfurl.vue')
  })
  routes.push({
    path: '/landing/:custom_slug/unfurl/ad',
    name: 'unfurlAdPage',
    component: () => import('@/views/Unfurl.vue'),
    props: { ad: true }
  })
  routes.push({
    path: '/landing/:custom_slug/unfurl/preview',
    name: 'unfurlPreviewPage',
    component: () => import('@/views/UnfurlPreview.vue')
  })
  routes.push({
    path: '/landing/:custom_slug',
    name: 'customTestLandingPage',
    component: () => import('@/views/CustomTestLandingPage.vue')
  })
  routes.push({
    path: '*',
    name: '404',
    component: () => import('@/views/404.vue')
  })
} else {
  routes.push({
    path: '/',
    name: 'landing',
    props: true,
    component: () => import('@/views/CustomTestLandingPage.vue')
  })
  routes.push({
    path: '/:custom_slug/subscribed',
    name: 'testSubscribedPage',
    component: () => import('@/views/TestSubscribedPage.vue')
  })
  routes.push({
    path: '/:custom_slug/unfurl',
    name: 'unfurlPage',
    component: () => import('@/views/Unfurl.vue')
  })
  routes.push({
    path: '/:custom_slug/unfurl/ad',
    name: 'unfurlAdPage',
    component: () => import('@/views/Unfurl.vue'),
    props: { ad: true }
  })
  routes.push({
    path: '/:custom_slug/unfurl/preview',
    name: 'unfurlPreviewPage',
    component: () => import('@/views/UnfurlPreview.vue')
  })
  routes.push({
    path: '/:custom_slug',
    name: 'customTestLandingPage',
    component: () => import('@/views/CustomTestLandingPage.vue')
  })
  routes.push({
    path: '*',
    name: '404',
    component: () => import('@/views/404.vue')
  })
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('setQueryVars', {
    noCookies: ('no-cookies' in to.query),
    noCapture: ('no-capture' in to.query),
    noCookiesPop: ('no-cookies-pop' in to.query),
    navOn: ('nav-on' in to.query),
    showDebugData: ('debug' in to.query)
  })
  next()
})

export default router
